import { render, staticRenderFns } from "./info-edit.vue?vue&type=template&id=241ae35e&scoped=true&"
import script from "./info-edit.vue?vue&type=script&lang=js&"
export * from "./info-edit.vue?vue&type=script&lang=js&"
import style0 from "./info-edit.vue?vue&type=style&index=0&id=241ae35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ae35e",
  null
  
)

export default component.exports